import type { PrivateEventCrewView } from '../../api/privateEvents';
import { useViewport } from '../../hooks/useViewport';

import ClientDealContact from './ClientDealContact';
import Fact from './Fact';

/** Who the event is for and who to reach on the day, without the deal. */
export default function ClientContactView({ event }: { event: PrivateEventCrewView }) {
  const { isPhone } = useViewport();
  return (
    <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1.3fr 1fr', gap: 14 }}>
      <Fact label="Client">
        <strong>{event.clientName}</strong>
      </Fact>
      <Fact label="Point of contact">
        <div style={{ fontWeight: 700 }}>{event.contactName || '—'}</div>
        <ClientDealContact event={event} />
      </Fact>
    </div>
  );
}
